export { default as SingleLogin } from './SingleLogin'

export { default as AdminLogin } from './AdminLogin'

export { default as CompanyLogin } from './CompanyLogin'
